var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error && _vm.error.code)?_c('components-error',{attrs:{"error":_vm.error}}):_c('div',{style:({backgroundColor:_vm.meta.background || '#fff'}),attrs:{"id":"main"}},[_c('div',{staticClass:"app-header"}),_c('div',{staticClass:"app-container"},[_c('router-view',{key:_vm.route_key})],1),_c('div',{staticClass:"app-footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }